import script from "./RightTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./RightTitle.vue?vue&type=script&lang=ts&setup=true"

import "./RightTitle.vue?vue&type=style&index=0&id=7ba11fa8&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba11fa8"]])

export default __exports__